import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTE_CONFIGS } from '../configs/routerConfig';
import { LSkeys } from '../configs/app.constants';
import { LstorageService } from '../services/common/lstorage.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authToken = inject(LstorageService).getItem(LSkeys.AUTH_TOKEN);
  return authToken ? true : inject(Router).navigateByUrl(ROUTE_CONFIGS.LOGIN_ROUTE);
};
export const revAuthGuard: CanActivateFn = (route, state) => {
  const authToken = inject(LstorageService).getItem(LSkeys.AUTH_TOKEN);
  return authToken ? inject(Router).navigateByUrl(ROUTE_CONFIGS.CUSTOMER_BOOKING_ROUTE) : true;
};
export const authGuardLanding: CanActivateFn = () => {
  const authToken = inject(LstorageService).getItem(LSkeys.AUTH_TOKEN);
  return authToken ? inject(Router).navigateByUrl(ROUTE_CONFIGS.CUSTOMER_BOOKING_ROUTE) : true;
};
